import React, { Fragment } from 'react'
import SiteHeader from '../../../components/SiteHeader';
import Breadcumb from '../../../components/Breadcumb'
import TeamMember from '../../../components/TeamMember'
import CallToAction from '../../../components/CallToAction'
import FooterArea from '../../../components/FooterArea'
import Seo from '../../../components/Seo'
import { breadcrumbSchema, attorneySchema, SITE_URL } from '../../../seo/config'
import { ATTORNEYS } from '../../../data/attorneys'
// images
import breadcumb from '../../../images/breadcumb/teams_cover.png'

import './style.scss'

const breadcumbMenu = [
    { name: 'Home', route: '/' },
    { name: 'Our Team' }
]

const TeamPage = () => {
    return (
        <Fragment>
            <Seo
                title="Our Legal Team — Advocates at Legal Corridor"
                description="Meet the experienced advocates and legal professionals at Legal Corridor, Delhi. A dedicated team handling civil, criminal, family, property and corporate matters."
                path="/team"
                schema={[
                    breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Our Team', path: '/team' }]),
                    ...ATTORNEYS.map((a) =>
                        attorneySchema({ name: a.name, jobTitle: a.jobTitle, url: `${SITE_URL}/team#${a.id}` })
                    ),
                ]}
            />
            <SiteHeader />
            <main>
            <Breadcumb
                className="breadcumbArea"
                title="Our Legal Team"
                breadcumbMenu={breadcumbMenu}
                background={breadcumb}
            />

            {/* Team Introduction */}
            {/* <section className="teamIntroSection">
                <div className="container">
                    <div className="sectionTitle">
                        <span>Meet Our Experts</span>
                        <h2>Experienced Legal Professionals</h2>
                    </div>
                </div>
            </section> */}

            <TeamMember
                title="Qualified Lawyers"
                subTitle="Meet Our Experts"
                description="Our team of highly skilled and dedicated legal professionals works collaboratively to provide comprehensive legal solutions. Each member brings unique expertise and a passion for the law."
                className="teamArea teamAreaStyleTwo"
            />


            <CallToAction />
            </main>
            <FooterArea />
        </Fragment>
    )
}
export default TeamPage